<template>
    <div class="cart mb-4" v-if="cartTotal !== '$0'">
         <h5 class="cart-header">Your Cart</h5>
    
            <div class="col">
      <!-- {{ this.products }} -->
     
      <!-- <ModalView v-show="this.displayModal" @close="closeModal" :data="this.selectedProduct"/> -->
      <ProductRow v-for="product in products"
        :key="product.id" :image="product.image" :title="product.title" :description="product.description" @click="showProduct(product)"
        :price="product.price"/>
    
        </div>
        <h4 v-if="cartTotal">Your total is {{ cartTotal }}</h4>
        
    </div>
    <div class="cart" v-else>
        <h5 class="cart-header">Your Cart</h5>
<i class="bi bi-cart-fill"></i>
<h6>Your Cart Is Empty</h6>
    </div>

</template>

<script>
import ProductRow from './ProductRow.vue';
//import ModalView from './Modal.vue';
export default {
  name: 'ProductsGrid',
  data(){
    return{
   //displayModal:false,
   selectedProduct:Object,
    }
  },
  mounted() {
    console.log(this.products)
  },
  props: {
    products: Array
  },
  components: {
    ProductRow,
    //ModalView
  },
  methods:{
    showProduct(product){
      console.log(JSON.stringify(product))
      this.$router.push("/product")
      this.$store.commit('selectedItem', product)
    },
    // closeModal(){
    //   this.displayModal = false
    // }
  },computed:{
    cartTotal(){
      let total = 0
      this.$store.state.cart.forEach((product)=>{
        total += product.price
      })
      return "$" + total + ""
    }
  }
}
</script>

<style scoped>
.cart{

    border-style: solid;
    border-color: orange;
    border-width: 4px;
    border-radius: 12px;
    overflow-y: scroll;
}
.cart-header{
    background-color: orange;
    color: white;
}
</style>